import { Personeelsdienst } from "@personeel/components/Werklijnen/Personeelsdiensten/Personeelsdienst/Personeelsdienst.tsx";
import { PersoneelsdienstLabel } from "@personeel/components/Werklijnen/Personeelsdiensten/PersoneelsdienstLabel/PersoneelsdientLabel.tsx";
import { PersoneelsdienstenModel } from "@personeel/models/PersoneelsdienstenModel.ts";

interface IPersoneelsdienstContainer {
  dienst: PersoneelsdienstenModel;
  scale: number;
}

export function PersoneelsdienstContainer({ dienst, scale }: Readonly<IPersoneelsdienstContainer>) {
  return (
    <>
      <PersoneelsdienstLabel
        standplaatsDrglptNaam={dienst.standplaatsDrglptNaam}
        dienstnummer={dienst.dienstnummer}
        diensten={dienst.personeelsdiensten}
      />

      <Personeelsdienst dienst={dienst} scale={scale} expanded={false} />
    </>
  );
}
